.customFiltersContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ant-margin-xs);
  margin-bottom: var(--ant-margin-md);
  position: relative;
}

.addFilterWrapper {
  position: relative;
}

.filtersDropdown {
  position: absolute;
  left: 0;
  top: var(--ant-theme-size-xl);
  z-index: 2;
  max-width: 300px;
  background: var(--ant-color-white);
  box-shadow: 0 4px 12px var(--ant-color-border) !important;
}

.filtersDropdown > li {
  overflow: ellipsis;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.filtersDropdown :global(.ant-menu-sub) {
  background-color: var(--ant-color-white) !important;
}

.dropdownContent {
  position: absolute;
  background: var(--ant-color-white);
  padding: var(--ant-padding);
  box-shadow: 0 4px 12px var(--ant-color-border) !important;
  min-width: 240px;
  left: calc(100% + var(--ant-padding) * 2);
}

.filterLabel {
  cursor: pointer;
  display: block;
  width: 100%;
}

.filterTag {
  border: 1px solid var(--ant-color-border-secondary);
  border-radius: var(--ant-border-radius-sm);
  display: flex;
  align-items: center;
}

.small {
  font-size: var(--ant-font-size-sm);
  padding: 2px var(--ant-padding-xs);
}

.middle {
  font-size: var(--ant-font-size-sm);
  padding: var(--ant-padding-xxs) var(--ant-padding-sm);
}

.large {
  font-size: var(--ant-font-size-md);
  padding: var(--ant-padding-sm) var(--ant-padding-md);
}

.resetAllButton {
  margin-left: auto;
  padding: 0;
  white-space: nowrap;
}
